import { createRouter, createWebHistory } from 'vue-router'
import PublicView from '@/views/PublicView.vue'
import MainView from '@/views/MainView.vue'

const routes = [
    {
        path: '/',
        name: 'public',
        component: PublicView,
        meta: { requiresAuth: true }
    },
    {
        path: '/main',
        name: 'main',
        component: MainView,
        meta: { requiresAuth: true }
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/'
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// Remove the check for termsAccepted since it's no longer necessary
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // Add your authentication logic here if needed, or remove if not necessary
        next();
    } else {
        next();
    }
});

export default router;